// Need the following styles for PDF viewer
// eslint-disable-next-line no-restricted-imports
import "@react-pdf-viewer/core/lib/styles/index.css";
// eslint-disable-next-line no-restricted-imports
import "@react-pdf-viewer/toolbar/lib/styles/index.css";

import { Box, useMediaQuery, useTheme } from "@mui/material";
import { RotateDirection, SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core";
// eslint-disable-next-line n/no-extraneous-import
import { SelectionMode } from "@react-pdf-viewer/selection-mode";
import { toolbarPlugin, type ToolbarSlot } from "@react-pdf-viewer/toolbar";

interface PdfDisplayProps {
  documentUrl: string;
  defaultScale?: number;
}

export function PdfDisplay(props: PdfDisplayProps) {
  const { documentUrl, defaultScale } = props;
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down("md"));

  const toolbarPluginInstance = toolbarPlugin({
    selectionModePlugin: { selectionMode: SelectionMode.Hand },
    zoomPlugin: { enableShortcuts: false },
  });

  const { Toolbar } = toolbarPluginInstance;

  return (
    // https://react-pdf-viewer.dev/docs/basic-usage/
    <Worker workerUrl="/pdfjs-dist/pdf.worker.min.js">
      <Toolbar>
        {(slots: ToolbarSlot) => {
          // oxlint-disable-next-line typescript/unbound-method
          // oxlint-disable-next-line typescript/unbound-method
          // oxlint-disable-next-line typescript/unbound-method
          // oxlint-disable-next-line typescript/unbound-method
          const { Zoom, ZoomIn, ZoomOut, Rotate } = slots;
          return (
            <Box
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Rotate direction={RotateDirection.Forward} />
              <Rotate direction={RotateDirection.Backward} />
              <ZoomOut />
              <Zoom />
              <ZoomIn />
            </Box>
          );
        }}
      </Toolbar>
      <Viewer
        fileUrl={documentUrl}
        plugins={[toolbarPluginInstance]}
        defaultScale={isTabletOrSmaller ? SpecialZoomLevel.PageWidth : (defaultScale ?? 0.5)}
      />
    </Worker>
  );
}
